import Http from "@/api/http";

export default {
  /* 年级班级管理 */
  /* 年级 列表 */
  gradeClassPage: params => {
    return Http.POST("/gradeClass/findByPage", params);
  },
  /* 年级 新增/修改 */
  gradeClassSave: params => {
    return Http.POST("/gradeClass/save", params);
  },
  // 删除
  gradeClassDelete: params => {
    return Http.GET("/gradeClass/delete", params);
  },
};
